import { createLogger, Logger } from '@vp/ubik-logging'
import { LoggerOptions } from '@vp/ubik-fragment-types'
import { LOGGER_SERVICE_NAME } from 'shared/constants'

const defaultLoggerOptions: LoggerOptions = { serviceName: LOGGER_SERVICE_NAME }

let loggerInstance: Logger | null = null

export const configureLogger = (options?: LoggerOptions) => {
  if (!loggerInstance) {
    loggerInstance = createLogger(options ?? defaultLoggerOptions)
  }
}

export const getLogger = () => {
  if (!loggerInstance) {
    throw new Error('Logger is not initialized. Call configureLogger() first.')
  }
  return loggerInstance
}

export default getLogger
